export enum TransactionStatus {
    Ok,
    Warning,
    Error
}